import { Card, CardBody, Col, Table } from "reactstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
 import OrganizationPaymentsBody from "./OrganizationPaymentsBody";
import CommonCardHeader from "../../../common-elements/common-card-header/CommonCardHeader";

const OrganizationPayments = () => {
  const [showCount, setShowCount] = useState(4);
  const navigate = useNavigate();

  const handleDropdownAction = (action: string) => {
    switch (action) {
      case "This Week":
        setShowCount(6);
        break;
      case "This Month":
        setShowCount(9);
        break;
      case "View All":
        navigate(`${process.env.PUBLIC_URL}/dashboard`);
        break;
      default:
        break;
    }
  };

  return (
    <Col lg="7" sm="12" className='m-0'>
      <Card className="payment-history" >
        <CommonCardHeader
          headClass="pb-0"
          title="Payment History"
          firstItem="This Week"
          secondItem="This Month"
          thirdItem="View All"
          mainTitle={true}
          onDropdownAction={handleDropdownAction}
        />
        <CardBody>
          <div className="custom-scrollbar">
            <Table responsive className="display" style={{ width: "100%" }}>
              <tbody>
                <OrganizationPaymentsBody showCount={showCount} />
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrganizationPayments;